export const insyncTheme = {
  color: {
    bg: '#0f0f10',
    panel: '#181614',
    panelAlt: '#211d19',
    border: '#38312b',
    text: '#f7f2ee',
    muted: '#b8aba1',
    accent: '#ff7a1a',
    accentHover: '#ff8f3d',
    accentSoft: '#3a2416',
    accentForeground: '#111111',
    controlBg: '#ffffff',
    controlText: '#1f1b18',
    optionBg: '#151210',
    success: '#4ade80',
    warning: '#fbbf24',
    danger: '#f87171',
    white: '#ffffff',
  },
  radius: {
    sm: '6px',
    md: '8px',
  },
} as const;

export default insyncTheme;
